export default __webpack_public_path__ + "static/media/foto_01.02361071.jpg";